<div class="progress-bar-wrapper standard-container pb-4" #container>
  @if (formStepperRef?.swiperInstance()) {
    <div class="z-3 sticky top-0 bg-white">
      <dojo-swiper-progress
        #progressBar
        class="progress-bar"
        [swiperInstance]="formStepperRef.swiperInstance()!"
      ></dojo-swiper-progress>
    </div>
  } @else {
    <dojo-loader [fullHeight]="true" [centered]="true" />
  }
</div>
<ion-content scrollEvents="true" (ionScroll)="onScroll($event)">
  <div class="standard-container h-full" [@appearDisappear]>
    <div>
      <dojo-sensei
        class="assessment-sensei block max-w-[400px]"
        [activeStoryCharacter]="defaultSenseiCharacter"
        [activeSpeechBubble]="state.activeSpeechBubble"
      />
    </div>
    <dojo-swiper-stepper
      [submitFn]="confirmFn"
      [form]="form"
      [swiperOptions]="swiperStepperOptions"
      #formStepperRef
      class="pb-4"
    >
      @for (slide of slides; track slide.formSettings?.formKey) {
        <swiper-slide [controlName]="slide.formSettings.formKey">
          @switch (slide.formSettings.formKey) {
            @case ('basicInfo') {
              <dojo-assessment-basic [assessmentBasicForm]="form.controls.basicInfo" />
            }
            @case ('typeSelection') {
              <dojo-assessment-type-selection
                [formCtrl]="form.controls.typeSelection.controls.assessmentType"
                [options]="(slide.formSettings.options$ | async) ?? []"
              />
            }
            @case ('tl2Selection') {
              <div class="wrapper-height">
                <dojo-assessment-tl2-selector
                  [formCtrl]="form.controls.tl2Selection.controls.selectedTopics"
                  class="pt-1"
                />
              </div>
            }
          }
        </swiper-slide>
      }
    </dojo-swiper-stepper>
  </div>
</ion-content>
<dojo-footer-panel (leftButtonClicked)="closeForm()" [leftButtonLabel]="'quit'">
  <div class="right">
    <dojo-button class="w-full md:min-w-[178px]" swiperStepperNext [swiperStepper]="formStepperRef">
      {{ 'continue' | transloco }}
    </dojo-button>
  </div>
</dojo-footer-panel>
